import { Box, Flex, Grid, Text } from '@chakra-ui/react'
import { motion, AnimatePresence } from 'framer-motion'
import { LuX as X } from 'react-icons/lu'
import { themeColors, brand } from '../../../../theme'
import { formatDistance, formatDuration, type SegmentStats } from '../../../../lib/trackAnalytics'

const MotionBox = motion.create(Box)
const colors = themeColors

interface Props {
  /** A→B stats, o null si aún no hay tramo completo */
  segment: SegmentStats | null
  /** true cuando solo se eligió el punto A */
  awaitingSecond: boolean
  onClear: () => void
}

function Stat({ label, value }: { label: string; value: string }) {
  return (
    <Box>
      <Text fontSize="9px" textTransform="uppercase" letterSpacing="0.1em" fontWeight="bold" color={colors.textMuted}>
        {label}
      </Text>
      <Text fontSize="sm" fontWeight="700" color={colors.text}>
        {value}
      </Text>
    </Box>
  )
}

export default function MapOverlayStats({ segment, awaitingSecond, onClear }: Props) {
  const visible = segment != null || awaitingSecond

  return (
    <AnimatePresence>
      {visible && (
        <MotionBox
          position="absolute"
          top={3}
          right={3}
          zIndex={1000}
          width={segment ? '260px' : 'auto'}
          maxW="calc(100% - 24px)"
          bg="white"
          borderRadius="xl"
          border="1px solid"
          borderColor={colors.border}
          boxShadow="0 4px 16px rgba(0,0,0,0.12)"
          p={4}
          initial={{ opacity: 0, y: -8 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -8 }}
          transition={{ duration: 0.2 }}
        >
          <Flex justifyContent="space-between" alignItems="center" mb={segment ? 3 : 0} gap={3}>
            <Text fontSize="xs" fontWeight="bold" color={brand.green} textTransform="uppercase" letterSpacing="0.08em">
              {segment ? `Tramo · puntos ${segment.fromIndex + 1}–${segment.toIndex + 1}` : 'Selecciona el 2.º punto'}
            </Text>
            <Box
              as="button"
              p={1}
              borderRadius="md"
              cursor="pointer"
              color={colors.textMuted}
              _hover={{ bg: colors.bgHover, color: colors.text }}
              onClick={onClear}
            >
              <X size={14} />
            </Box>
          </Flex>

          {segment && (
            <Grid templateColumns="repeat(2, 1fr)" gap={3}>
              <Stat label="Tiempo" value={formatDuration(segment.totalDurationMs)} />
              <Stat label="Distancia" value={formatDistance(segment.totalDistanceM)} />
              <Stat label="Vel. prom." value={`${segment.avgSpeedKmh.toFixed(1)} km/h`} />
              <Stat label="Vel. máx." value={`${segment.maxSpeedKmh.toFixed(1)} km/h`} />
              <Stat label="Detenido" value={formatDuration(segment.stoppedDurationMs)} />
              <Stat label="Paradas" value={String(segment.intermediateStops.length)} />
            </Grid>
          )}
        </MotionBox>
      )}
    </AnimatePresence>
  )
}
